module.exports = __webpack_public_path__ + "static/media/cynergy-bank.ce2f9719.svg";